<template>
  <div v-if="errors.length === 0" class="container-fluid d-flex justify-content-center public-survey">

      <b-row class="m-4 contenue d-flex justify-content-center">
        <b-col cols="12" class="d-flex justify-content-center mt-4">
          <page-title class="title" :style="{'width': widthTitle }">
            {{ $t('_survey_question')}}
          </page-title>
        </b-col>

        <b-col cols="12" class="d-flex justify-content-center">
          <div v-if="questions.length" class="d-flex justify-content-center" :style="{'width': width}">
            <form @submit="onSubmit" class="formulaire" :style="{'display': display}">
              <custom-input-controller :verticalClass="true" :fields="questions"
                                       @input="onInput"
              />

              <div class="send-button centered-button mt-4">
                <submit class="form-button"/>
              </div>
            </form>

            <div v-if="isReplySubmitted" class="col-12 text-center">
              <b-alert v-if="success" variant="success" show>
                {{ $t('surveyReply.alert.successPublic') }}
              </b-alert>

              <b-alert v-else variant="danger" show>
                {{ $t('surveyReply.error.'+errorCode) }}
              </b-alert>
            </div>
          </div>

          <div v-else class="notfound">
            {{ $t('surveyReply.error.unavailable') }}
          </div>
        </b-col>
      </b-row>
  </div>

  <div v-else class="errors text-center">
    <div v-for="error in errors" v-bind:key="error" class="text-center">
      <h2> {{ $t(`error.${error}`) }}</h2>
    </div>
  </div>
</template>

<script>
import pageTitle from '@/components/frontoffice/pageTitle'
import frontofficeFrame from '@/components/frontoffice/frame'
import frontofficeLoader from '@/components/frontoffice/loader'
import CommonApi from '@/api/commonApi'
import customInputController from '@/components/frontoffice/form/customInput/controller'
import submit from '@/components/frontoffice/form/baseInput/submit'
import FormSubmitter from '@/api/formSubmitter'
import booleanInput from '@/components/frontoffice/form/customInput/boolean'
import numberInput from '@/components/frontoffice/form/customInput/number'
import selectInput from '@/components/frontoffice/form/customInput/select'
import textInput from '@/components/frontoffice/form/customInput/text'
import { fieldTypes, getComponent } from '@/utils/fieldTypeCodes'

export default {
  components: {
    pageTitle,
    frontofficeFrame,
    frontofficeLoader,
    customInputController,
    submit,
    booleanInput,
    numberInput,
    selectInput,
    textInput
  },
  data () {
    return {
      token: this.$route.params['token'],
      context: this.$route.name,
      commonApi: new CommonApi(),
      isReplySubmitted: false,
      questions: {},
      errors: [],
      errorCode: null,
      success: true,
      display: 'block',
      width: '80%',
      widthTitle: '50%'
    }
  },

  created () {
    this.commonApi.surveyQuestionsPublic(this.token)
      .then(response => {
        if (response.data.success) {
          this.questions = response.data.data

          for (let question of this.questions) {
            // custom input controller needs a "type" field instead of "field_type"
            question = this.renameObjectKey(question, 'field_type', 'type')

            switch (question.type) {
              case fieldTypes.NUMERIC:
                question.range = true
                question.min = 1
                question.max = 5
                question.value = 1
                question.response = 1
                break
              case fieldTypes.TEXT:
                question.response = ''
                break
              case fieldTypes.DROP_DOWN_MENU:
                // "Yes" is not selected by default
                question.options = [
                  {value: 'yes', label: '_yes', selected: false},
                  {value: 'no', label: '_no', selected: false}
                ]
                question.response = undefined
                break
              case fieldTypes.BOOLEAN:
                question.response = this.$t('_no')
                break
            }
          }
        } else {
          Object.entries(response.data.errors).forEach(error => {
            this.errors.push(this.$te(`error.${error[0]}`)
              ? error[0]
              : error[1]
            )
          })
        }
      })
  },

  methods: {
    renameObjectKey (obj, oldKey, newKey) {
      Object.defineProperty(obj, newKey, Object.getOwnPropertyDescriptor(obj, oldKey))
      delete obj[oldKey]

      return obj
    },

    onInput (response) {
      let question = this.questions.find(question => {
        return question.id === response.id
      })

      if (question.type === fieldTypes.BOOLEAN) {
        question.response = this.$t(`_${response.value}`)
      } else {
        question.response = response.value
      }
    },

    onSubmit (event) {
      event.preventDefault()
      let submitter = new FormSubmitter('public_survey')
      submitter.submitRequest(this.questions, this.token)
        .then(response => {
          this.isReplySubmitted = true
          if (response.data.success) {
            this.display = 'none'
            this.width = '100%'
            this.widthTitle = '100%'
          } else {
            this.display = 'none'
            this.width = '100%'
            this.widthTitle = '100%'
            this.errorCode = response.data.errors[0]
            this.success = false
          }
        })
    }
  }
}
</script>

<style scoped>

.public-survey .contenue .title{
  font-family: "prata", serif;
  font-size: 2rem;
  color: #1A2050;
  margin: 2rem 0;
  border-bottom: 1px solid #E65011;
  padding-bottom: 1rem;
  text-align: center;
}

.public-survey .formulaire{
  width: 60%;
}
</style>
